import { api } from '../../../shared/api/client';

export const getPayOuts = (params = {}) => api.post('pay-out/getPayOuts', params);
export const getTop = (params = {}) => api.post('pay-out/getTop', params);

export const adminGetPayOuts = (params = {}) => api.post('admin/pay-out/getPayOuts', params);
export const approve = (uuid = {}) => api.post('admin/pay-out/approve', {}, { params: { uuid } });
export const callback = (uuid = {}) => api.get('admin/pay-out/callback', { params: { uuid } });
export const cancel = (uuid = {}) => api.post('admin/pay-out/cancel', {}, { params: { uuid } });
export const complete = (uuid = {}) => api.post('admin/pay-out/complete', {}, { params: { uuid } });
export const getBillImage = (uuid = {}) => api.get('admin/pay-out/getBillImage', { params: { uuid } });
export const retry = (uuid = {}) => api.post('admin/pay-out/retry', {}, { params: { uuid } });
export const getLogs = (payOutId = {}) => api.get('admin/log-pay-out/getLogs', { params: { pay_out_id: payOutId } });
export const release = (uuid = {}) => api.get('admin/log-pay-out/release', { params: { uuid } });
export const toggleState = (uuid = {}) => api.get('admin/log-pay-out/toggleState', { params: { uuid } });

export const exportFile = async (params, filename) => {
    const result = await api.download('admin/pay-out/exportFile', { params, filename });
    if (result instanceof Blob) {
        return { success: true };
    }
    return result;
};
